export default __webpack_public_path__ + "static/media/certidao.e4bcaa98.jpg";